import PropTypes from 'prop-types';
import { sendCommand } from '../utils/mobile';

let current = null;

const StatusBarStyle = ({ color, barStyle }) => {
  if (current !== `${color}:${barStyle}`) {
    current = `${color}:${barStyle}`;
    sendCommand('status-bar-style', { color, style: barStyle });
  }

  return null;
};

StatusBarStyle.propTypes = {
  color: PropTypes.string,
  barStyle: PropTypes.string,
};

export default StatusBarStyle;



// WEBPACK FOOTER //
// ./src/components/StatusBarStyle.js